module.exports = __webpack_public_path__ + "static/media/Link-Authorization.999040fa.png";